var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeDots = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 8.36719C9.5625 7.5 8.86719 6.80469 8 6.80469C7.14062 6.80469 6.44531 7.5 6.44531 8.36719C6.44531 9.23438 7.14062 9.92969 8 9.92969C8.86719 9.92969 9.5625 9.23438 9.5625 8.36719Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3672 8.36719C15.3672 7.5 14.6719 6.80469 13.8047 6.80469C12.9219 6.80469 12.2266 7.5 12.2266 8.36719C12.2266 9.23438 12.9219 9.92969 13.8047 9.92969C14.6719 9.92969 15.3672 9.23438 15.3672 8.36719Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 8.36719C3.78125 7.5 3.07812 6.80469 2.19531 6.80469C1.33594 6.80469 0.632812 7.5 0.632812 8.36719C0.632812 9.23438 1.33594 9.92969 2.19531 9.92969C3.07812 9.92969 3.78125 9.23438 3.78125 8.36719Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ThreeDots.d32d5c4b48b131da52128103c440fbf8.svg";